module.exports = "pegasus_template/assets/blocks/capture-10-basic.png";